import { companyRequest } from '@/company/api';
import type { ShareAccess } from './types';
import type { ShareKind } from './sharing-policy';
import { sharingCopyFor } from './sharing-copy.ts';

export type { ShareKind };
export type ShareAudience = NonNullable<ShareAccess['audience']>;
export interface SharingRequest {
  id: string;
  kind: ShareKind;
  itemId: string;
  title?: string;
  status: string;
  action: string;
  change?: {
    visibility?: 'private' | 'members' | 'company';
    audience?: ShareAudience;
    title?: string;
    payload?: unknown;
    revision?: number;
  };
  snapshot?: Record<string, unknown>;
  createdAt?: string;
  decidedAt?: string | null;
}
export type SharingRequestDetail = { request: SharingRequest; canPublish: boolean };
const root = '/api/v1/company/sharing';
export const sharingApi = {
  list: () => companyRequest<{ requests: SharingRequest[]; canPublish: boolean }>(root),
  colleagues: () =>
    companyRequest<{ members: { userId: string; displayName: string | null; email: string }[] }>(
      '/api/v1/company/colleagues',
    ),
  save: (input: {
    kind: ShareKind;
    id: string;
    visibility: 'private' | 'members' | 'company';
    audience: ShareAudience;
    revision?: number;
  }) =>
    companyRequest<{
      status: 'applied' | 'pending';
      request?: SharingRequest;
      creatorNotified?: boolean;
      notifiedUserIds?: string[];
    }>(root, 'POST', {
      ...input,
      confirmed: true,
    }),
  read: (id: string) => companyRequest<SharingRequestDetail>(`${root}/${encodeURIComponent(id)}`),
  content: (id: string, offset = 0) =>
    companyRequest<{ content: string; totalCharacters: number; nextOffset: number | null }>(
      `${root}/${encodeURIComponent(id)}/content?offset=${offset}&length=16000`,
    ),
  decide: (id: string, approve: boolean) =>
    companyRequest(`${root}/${encodeURIComponent(id)}/${approve ? 'approve' : 'reject'}`, 'POST', {
      confirmed: true,
    }),
};

export function audienceLabel(item: ShareAccess, companyName = 'Poneva', locale: string) {
  const copy = sharingCopyFor(locale);
  return item.visibility === 'company'
    ? copy.audienceEveryone.replace('{company}', companyName)
    : item.visibility === 'members'
      ? copy.audienceSelected
      : copy.audienceOnlyMe;
}
